// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kore-chat-window .piechartDiv .legend-title {
  fill: #8a959f;
}

.kore-chat-window .piechartDiv .legend-value {
  fill: #26344a;
}

.kore-chat-window .piechartDiv .chart-disp-val {
  fill: #26344a;
}

.kore-chat-window .piechart .piechartDiv {
  display: block;
  border-radius: 4px;
  clear: both;
  width: 353px;
  margin-left: -45px;
  box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);
  cursor: pointer;
}

.kore-chat-window .piechart .messageBubble.pieChart {
  margin-bottom: 10px;
}

.kore-chat-window .piechart .profile-photo {
  top: 45px;
}

.kore-chat-window .piechart .piechartDiv {
  display: block;
  border-radius: 4px;
  clear: both;
  width: 353px;
  margin-left: -45px;
  box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);
  cursor: pointer;
  background: #fff;
}

.kore-chat-window .piechart .piechartDiv .legend-tooltip-pie-chart {
  position: absolute;
  background: #fff;
  box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);
  height: 150px;
  overflow-y: scroll;
}

.kore-chat-window .legend-tooltip-pie-chart::-webkit-scrollbar {
  width: 4px;
}

.kore-chat-window .legend-tooltip-pie-chart::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.kore-chat-window .legend-tooltip-pie-chart::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}

.kore-chat-window .legend-tooltip-pie-chart {
  background: #fff;
  box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);
  height: 105px;
  padding-bottom: 6px;
  overflow-y: scroll;
}

.kore-chat-window .piechart .messageBubble.pieChart {
  margin-bottom: 10px;
}

.kore-chat-window .piechart .profile-photo {
  top: 30px;
}

/* pie chart polylines and labels start */
.kore-chat-window polyline {
  opacity: 0.3;
  stroke: black;
  stroke-width: 1px;
  fill: none;
}

.kore-chat-window .labelName tspan {
  font-style: normal;
  font-weight: 700;
}

.kore-chat-window .labelName {
  font-size: 0.9em;
  font-style: italic;
}

/* pie chart polylines and labels end */`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/pieChartTemplate/pieChartTemplate.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AACA;EACI,aAAA;AAEJ;;AAAA;EACI,aAAA;AAGJ;;AADA;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iDAAA;EACA,eAAA;AAIJ;;AADA;EACI,mBAAA;AAIJ;;AADA;EACI,SAAA;AAIJ;;AADA;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iDAAA;EACA,eAAA;EACA,gBAAA;AAIJ;;AADA;EACI,kBAAA;EACA,gBAAA;EACA,iDAAA;EACA,aAAA;EACA,kBAAA;AAIJ;;AAAA;EACG,UAAA;AAGH;;AAAA;EACI,4CAAA;EACD,oDAAA;AAGH;;AAAA;EACC,0BAAA;EACA,4BAAA;AAGD;;AAAA;EACI,gBAAA;EACA,iDAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAGJ;;AAAA;EACI,mBAAA;AAGJ;;AADA;EACI,SAAA;AAIJ;;AADA,yCAAA;AACA;EACI,YAAA;EACA,aAAA;EACA,iBAAA;EACA,UAAA;AAIJ;;AADA;EACI,kBAAA;EACA,gBAAA;AAIJ;;AADA;EACI,gBAAA;EACA,kBAAA;AAIJ;;AAFA,uCAAA","sourcesContent":[".kore-chat-window .piechartDiv .legend-title {\n    fill: #8a959f;\n}\n.kore-chat-window .piechartDiv .legend-value {\n    fill: #26344a;\n}\n.kore-chat-window .piechartDiv .chart-disp-val{\n    fill: #26344a;\n}\n.kore-chat-window .piechart .piechartDiv {\n    display: block;\n    border-radius: 4px;\n    clear: both;\n    width: 353px;\n    margin-left: -45px;\n    box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);\n    cursor: pointer;\n}\n\n.kore-chat-window .piechart .messageBubble.pieChart {\n    margin-bottom: 10px;\n}\n\n.kore-chat-window .piechart .profile-photo {\n    top: 45px;\n}\n\n.kore-chat-window .piechart .piechartDiv {\n    display: block;\n    border-radius: 4px;\n    clear: both;\n    width: 353px;\n    margin-left: -45px;\n    box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);\n    cursor: pointer;\n    background: #fff;\n}\n\n.kore-chat-window .piechart .piechartDiv .legend-tooltip-pie-chart {\n    position: absolute;\n    background: #fff;\n    box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);\n    height: 150px;\n    overflow-y: scroll;\n }\n\n\n.kore-chat-window .legend-tooltip-pie-chart::-webkit-scrollbar {\n   width: 4px;\n}\n\n.kore-chat-window .legend-tooltip-pie-chart::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n   -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n}\n\n.kore-chat-window .legend-tooltip-pie-chart::-webkit-scrollbar-thumb {\n background-color: darkgrey;\n outline: 1px solid slategrey;\n}\n\n.kore-chat-window .legend-tooltip-pie-chart {\n    background: #fff;\n    box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);\n    height: 105px;\n    padding-bottom: 6px;\n    overflow-y: scroll;\n } \n\n.kore-chat-window .piechart .messageBubble.pieChart {\n    margin-bottom: 10px;\n}\n.kore-chat-window .piechart .profile-photo {\n    top: 30px;\n}\n\n/* pie chart polylines and labels start */\n.kore-chat-window polyline{\n    opacity: .3;\n    stroke: black;\n    stroke-width: 1px;\n    fill: none;\n}\n\n.kore-chat-window .labelName tspan {\n    font-style: normal;\n    font-weight: 700;\n}\n\n.kore-chat-window .labelName {\n    font-size: 0.9em;\n    font-style: italic;\n}\n/* pie chart polylines and labels end */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
